import { render } from "./replace.vue?vue&type=template&id=289cab45"
import script from "./replace.vue?vue&type=script&lang=js"
export * from "./replace.vue?vue&type=script&lang=js"

import exportComponent from "/root/docuseal-plus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__